var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHr = function SvgHr(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21787_20794",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4171CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21787_20794)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#1F1FAE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 6.66667,
    height: 20,
    transform: "rotate(90 20 0)",
    fill: "#E33122"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 6.66602,
    width: 6.66667,
    height: 20,
    transform: "rotate(90 20 6.66602)",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5605 6.60002C10.4843 6.60239 7.48217 6.59836 6.4375 6.60002C6.5 13 6.43236 14.7962 10.0478 14.7962C13.5605 14.6799 13.5605 13 13.5605 6.60002Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4375 6.60002C6.68327 6.59963 7.0374 6.59956 7.47534 6.59964V7.73828H6.44854C6.44615 7.50969 6.44392 7.27431 6.44163 7.03197L6.4375 6.60002ZM6.47688 9.48068C6.49393 10.1324 6.5201 10.7115 6.56428 11.2246H7.47946V12.9648H9.21753V11.2246H10.9599V12.967H9.21774V14.7072H8.86144C9.20471 14.7683 9.5977 14.7962 10.0478 14.7962C10.409 14.7842 10.7324 14.7557 11.0221 14.7072H10.9636V12.9648H12.7019V11.2246H13.4344C13.4786 10.7133 13.5047 10.1345 13.5217 9.48068H12.706V11.2229H10.9636V9.48047H12.7019V7.7424H10.9636V6.60077C10.3472 6.6007 9.75902 6.6005 9.21774 6.60028V7.73828H10.9599V9.48068H9.21774V11.2229H7.47534V9.48068H6.47688ZM13.1281 12.967H12.706V13.8144C12.8817 13.5824 13.0195 13.3023 13.1281 12.967ZM7.47534 14.0507C7.20674 13.7784 7.0105 13.4222 6.86636 12.967H7.47534V14.0507ZM7.47946 9.48047H9.21753V7.7424H7.47946V9.48047ZM13.5497 7.73828H12.706V6.60053L13.5605 6.60002L13.5567 6.99988C13.5544 7.25374 13.5522 7.4998 13.5497 7.73828Z",
    fill: "#E33122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8105 6.60002V6.34983L13.5603 6.35003C11.8115 6.35137 10.0854 6.35065 8.7299 6.35008C7.70218 6.34965 6.88741 6.34931 6.4371 6.35003L6.18505 6.35043L6.18751 6.60247C6.18895 6.74922 6.19031 6.89364 6.19165 7.03574C6.20492 8.43979 6.21605 9.61772 6.26993 10.5944C6.32912 11.6673 6.4407 12.5217 6.67466 13.1816C6.91223 13.8517 7.2802 14.3323 7.84952 14.6361C8.40658 14.9333 9.12937 15.0462 10.0478 15.0462V15.0463L10.056 15.046C10.9483 15.0165 11.6542 14.8876 12.1998 14.5851C12.7569 14.2762 13.1211 13.8012 13.3569 13.1382C13.5891 12.4854 13.7001 11.6418 13.7552 10.5772C13.8105 9.51147 13.8105 8.2012 13.8105 6.60654V6.60002Z",
    stroke: "#E33122",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.80078 4.27926L6.54922 6.02562C9.54298 4.76159 12.2873 5.60982 13.2852 6.19194L14.1999 4.27926L13.3683 3.19818L12.3704 3.7803L11.7051 2.86554L10.7072 3.44766L9.79246 2.69922L8.96086 3.44766L8.12926 2.86554L7.29766 3.7803L6.13342 3.44766L5.80078 4.27926Z",
    fill: "#5454CC"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hr.e053a88023f896282f0214699d8fa0b5.svg";